import { render } from "./cotar-frete-editar-dedicada.vue?vue&type=template&id=2a990c89"
import script from "./cotar-frete-editar-dedicada.vue?vue&type=script&lang=js"
export * from "./cotar-frete-editar-dedicada.vue?vue&type=script&lang=js"

import "./cotar-frete-editar-dedicada.vue?vue&type=style&index=0&id=2a990c89&lang=css"

import exportComponent from "/home/econopro-ubuntu/Documents/econopro/fonts/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__